import { WaterBoilerIcon } from './WaterBoilerIcon';

/**
 * author: GreenTurtwig
 * id 02A9C002-3B54-415E-8199-067139DF771A
 * name water-boiler
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-boiler.svg
 * tags
 * - Home Automation 
 */
export const ElectricWaterBoilerIcon = WaterBoilerIcon;
export default ElectricWaterBoilerIcon